<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-container
    v-if="id!=='-1'"
    style="position: relative;height: 100vh;overflow-y: scroll"
  >
    <div
      class="d-flex flex-wrap align-center"
    >
      <slot name="navigation" />
      <div class="d-flex align-center">
        <back-button @close-event="closeDialog" />
        <page-header class="py-4 pb-6">
          {{ $t('billDetail') }} · #{{ id }}
        </page-header>
      </div>
      <v-spacer />
      <div class="d-flex align-center">
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <v-btn
            :disabled="billData.billInfo.paymentStatus==='0'||totalPrice<0 || isReturned"
            outlined
            style="background: white"
            @click="startChangePaymentMethodForOrder()"
          >
            {{ $t('changePayment') }}
          </v-btn>
          <v-btn
            :disabled="billData.billInfo.paymentStatus==='0'||totalPrice<0 || isReturned"
            class="ml-2"
            color="error darken-4"
            outlined
            style="background: white"
            @click="returnOrder"
          >
            {{ $t('billReturn') }}
          </v-btn>
          <v-btn
            class="ml-2"
            color="amber lighten-4 black--text"
            elevation="0"
            @click="reprintDialogShow=true"
          >
            {{ $t('reprint') }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            :disabled="billData.billInfo.paymentStatus==='0'||totalPrice<0"
            icon
            outlined
            style="background: white"
            @click="startChangePaymentMethodForOrder()"
          >
            <v-icon
              center
              color="black"
            >
              mdi-credit-card
            </v-icon>
          </v-btn>
          <v-btn
            :disabled="billData.billInfo.paymentStatus==='0'||totalPrice<0"
            class="ml-2"
            color="error darken-4"
            icon
            outlined
            style="background: white"
            @click="returnOrder"
          >
            <v-icon center>
              mdi-account-cash
            </v-icon>
          </v-btn>
          <v-btn
            class="ml-2"
            elevation="0"
            icon
            style="background-color: #ffa000"
            @click="reprintDialogShow=true"
          >
            <v-icon
              center
              color="white"
            >
              mdi-printer
            </v-icon>
          </v-btn>
        </template>
      </div>
    </div>
    <v-tabs v-model="tab">
      <v-tab>
        {{ $t('Information') }}
      </v-tab>
      <v-tab>
        {{ $t('dishInformation') }}
      </v-tab>
      <v-tab>
        {{ $t('ElectronicBill') }}
      </v-tab>
      <v-tab v-if="showFrenchBill === '1'">
        {{ $t('printFrenchBill') }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div
          class="d-flex"
        >
          <div
            :class="!$vuetify.breakpoint.mdAndUp ? 'order-1' : ''"
            class="flex-grow-1"
          >
            <v-card
              class="pr-4 mt-2"
              outlined
            >
              <div
                class="text-h4 pa-4 pl-9"
              >
                <v-icon
                  class="mr-2"
                >
                  mdi-timeline
                </v-icon>

                {{ $t('mealsDetail') }}
              </div>
              <v-divider />
              <v-timeline
                v-if="billTimeLine && billTimeLine.length > 0"
                align-top
                dense
              >
                <template v-for="(t,index) in displayTimeLineDetail">
                  <v-timeline-item
                    :key="index + t.eventName"
                    :color="(t.eventName === 'startNewOrder' || t.eventName === 'checkOutWithPL' || t.eventName === 'printZwischenBon') ? 'amber' : 'black'"
                    small
                  >
                    <div class="d-flex pr-4">
                      <div> {{ t.eventName }}</div>
                      <v-spacer />
                      {{ t.time | beautifulTime }}
                    </div>
                    <div
                      v-if="t.eventName === 'addDishToOrder'"
                      class="mt-4"
                    >
                      <div
                        v-for="(b) in t.value"
                        :key="b.id"
                      >
                        <v-card
                          class="pa-2 ml-0 ma-1 text-body-1"
                          color="#eee"
                          elevation="0"
                          @click="showJson(b)"
                        >
                          <div>
                            <div class="d-flex align-end justify-center">
                              <b>{{ Math.abs(b.dishInfo.count) }}&times; </b>
                              <span class="text-capitalize text-no-wrap text-truncate ml-2"> #{{
                                b.dishInfo.code
                              }} </span>
                              <span
                                class="text-caption ml-2"
                              >{{ changeFromTableInfo(b.opBrief) }}</span>
                              <v-spacer />
                              <template v-if="b.dishInfo.tempDiscountStr">
                                <span
                                  class="text-decoration-line-through warning--text text--darken-1"
                                  style="font-size: 10px"
                                >{{ b.dishInfo.price | priceDisplay }}</span>
                                <span class="text-no-wrap">
                                  {{ parseFloat(b.dishInfo.price) + parseFloat(b.dishInfo.tempDiscountMod) | priceDisplay }}</span>
                              </template>
                              <span
                                v-else
                                class="text-no-wrap"
                              >{{ b.dishInfo.price | priceDisplay }}</span>
                            </div>
                            <div class="d-flex">
                              <span class="maxLine2">{{ b.currentDishInfo?.code.toLowerCase().startsWith('ea') ? b.dishInfo.currentName : b.currentDishInfo?.name ? b.currentDishInfo?.name : (b.dishInfo.currentName ? b.dishInfo.currentName : b.dishInfo.name) }}</span>
                              <v-spacer />
                              <div>{{ b.servantName }}</div>
                            </div>
                          </div>
                          <template>
                            <div class="text-caption">
                              {{ b.dishInfo?.modName }}
                            </div>
                          </template>
                        </v-card>
                      </div>
                    </div>
                    <div
                      v-else-if="t.eventName === 'removeDishFromOrder'"
                      class="mt-4"
                    >
                      <div
                        v-for="(c,index) in t.value"
                        :key="c.id + index"
                      >
                        <v-card
                          class="pa-2 ml-0 ma-1 text-body-1"
                          color="#eee"
                          elevation="0"
                          @click="showJson(c)"
                        >
                          <div class="d-flex align-center justify-center">
                            <div>
                              <b>{{ Math.abs(c.detailInfo
                                .params.tt_dish.count ? c.detailInfo
                                  .params.tt_dish.count : c.detailInfo
                                  .params.tt_dish.sumCount) }}&times; </b>
                              <span class="text-capitalize text-no-wrap text-truncate ml-2"> #{{
                                c.detailInfo
                                  .params.tt_dish.code
                              }} </span>
                              <span class="text-caption">{{ changeToTableInfo(c.opBrief) }}</span>
                            </div>

                            <v-spacer />
                            <div class="d-flex flex-column">
                              <div>{{ c.detailInfo?.params?.reason }}</div>
                            </div>
                          </div>
                          <div class="d-flex align-center justify-center">
                            <div>{{ c.nameDisplay }}</div>
                            <v-spacer />
                            <div class="d-flex flex-column">
                              <div>{{ c.servantName }}</div>
                            </div>
                          </div>
                          <template>
                            <div class="text-caption">
                              {{ c.detailInfo
                                .params.tt_dish?.aName }}
                            </div>
                          </template>
                        </v-card>
                      </div>
                    </div>
                    <div
                      v-else
                      class="mt-4"
                    >
                      <div
                        v-for="(c,index) in t.value"
                        :key="c.id + index"
                      >
                        <v-card
                          class="pa-2 ml-0 ma-1 text-body-1"
                          color="#eee"
                          elevation="0"
                          @click="showJson(c)"
                        >
                          <div class="d-flex">
                            <div>
                              {{ c?.opBrief }}
                            </div>
                            <v-spacer />
                            <div>{{ c?.detailInfo?.params?.reason }}</div>
                          </div>
                        </v-card>
                      </div>
                    </div>
                  </v-timeline-item>
                </template>
              </v-timeline>
              <v-timeline
                v-else
                align-top
                dense
              >
                <v-timeline-item
                  color="amber"
                  small
                >
                  <div class="d-flex pr-4">
                    <div>{{ $t('startMeal') }}</div>
                    <v-spacer />
                    {{ basicInfo.startTime | beautifulTime }}
                  </div>
                </v-timeline-item>
                <template v-if="displayDetailInfo">
                  <template v-for="t in Object.keys(displayDetailInfo)">
                    <v-timeline-item
                      :key="t"
                      small
                    >
                      <div>
                        <div
                          v-for="op in Object.keys(displayDetailInfo[t])"
                          :key="t+'op'+op"
                        >
                          <div class="d-flex pr-4">
                            <div> {{ $t(op) }}</div>
                            <v-spacer />
                            {{ t | beautifulTime }}
                          </div>
                          <div class="mt-4">
                            <v-card
                              v-for="d in displayDetailInfo[t][op]"
                              :key="d.id"
                              class="pa-2 ml-0 ma-1 text-body-1"
                              color="#eee"
                              elevation="0"
                            >
                              <div>
                                <div class="d-flex">
                                  <b>{{ Math.abs(d.count) }}&times; </b>
                                  <span class="text-capitalize text-no-wrap text-truncate ml-2"> #{{
                                    d.currentCode
                                  }} </span>
                                  <v-spacer />
                                  <template v-if="parseFloat(d.tempDiscountMod)!==0">
                                    <span
                                      class="text-decoration-line-through warning--text text--darken-1"
                                      style="font-size: 10px"
                                    >{{ d.price | priceDisplay }}</span>
                                    <span class="text-no-wrap">
                                      {{ parseFloat(d.price) + parseFloat(d.tempDiscountMod) | priceDisplay }}</span>
                                  </template>
                                  <span
                                    v-else
                                    class="text-no-wrap"
                                  >{{ d.price | priceDisplay }}</span>
                                </div>
                                <div class="d-flex">
                                  <span class="maxLine2">{{ d.name }}</span>
                                  <v-spacer />
                                  <div>{{ d.servantName }}</div>
                                </div>
                              </div>
                              <template v-if="d.aName">
                                <div class="text-caption">
                                  {{ d.aName }}
                                </div>
                              </template>
                            </v-card>
                          </div>
                        </div>
                      </div>
                    </v-timeline-item>
                  </template>
                </template>
                <v-timeline-item
                  v-if="billData.billInfo.paymentStatus === '1'"
                  color="success"
                  small
                >
                  <div class="d-flex pr-4">
                    <div>{{ $t('endMeal') }}</div>
                    <v-spacer />
                    {{ basicInfo.endTime | beautifulTime }}
                  </div>
                </v-timeline-item>
              </v-timeline>
            </v-card>
            <v-card
              class="pa-4 px-8 mt-2 font-weight-regular"
              elevation="0"
              outlined
            >
              <table
                class="mt-6"
                style="width: 100%"
              >
                <tbody>
                  <tr>
                    <td style="width: 140px">
                      {{ $t('subtotal') }}
                    </td>
                    <td style="width: 140px">
                      {{ $t('numberOfGoods', { numberOfGoods: count }) }}
                    </td>
                    <td style="text-align: right">
                      {{ dishTotalPrice | priceDisplay }}
                    </td>
                  </tr>
                  <tr v-if="billData.billInfo.tipIncome>0">
                    <td style="width: 140px">
                      {{ $t('tips') }}
                    </td>
                    <td style="width: 140px" />
                    <td style="text-align: right">
                      {{ billData.billInfo.tipIncome | priceDisplay }}
                    </td>
                  </tr>
                  <tr v-if="billData.billInfo.discountStr">
                    <td style="width: 140px">
                      {{ $t('discount') }}
                    </td>
                    <td style="width: 140px">
                      {{ $t('totalPrice') }}
                    </td>
                    <td style="text-align: right">
                      {{ billData.billInfo.discountStr }}
                    </td>
                  </tr>
                  <tr class="font-weight-bold">
                    <td style="width: 140px">
                      {{ $t('totalPrice') }}
                    </td>
                    <td />

                    <td style="text-align: right">
                      {{ totalPrice | priceDisplay }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <v-divider class="my-4" />
              <div class="text-subtitle-2 font-weight-regular">
                {{ $t('userPay') }}
              </div>
              <v-card
                class="mt-2"
                elevation="0"
              >
                <div
                  v-for="item in paymentRecordList"
                  :key="item.id"
                  class="d-flex py-2"
                  style="font-size: 16px "
                >
                  <div
                    class="amber mr-6 px-2 white--text d-flex align-center justify-center"
                    style="border-radius: 8px"
                  >
                    {{ item.paymentMethodName }}
                  </div>
                  <v-spacer />
                  {{ item.amount | priceDisplay }}
                </div>
              </v-card>
            </v-card>
          </div>
          <div
            :class="!$vuetify.breakpoint.mdAndUp ? 'flex-grow-1 order-0 mt-2' : 'ml-8 mt-2 flex-shrink-0'"
            :style="!$vuetify.breakpoint.mdAndUp ? 'position: relative; width: 100%;' : 'position: sticky; top: 0; width: 300px;'"
          >
            <v-card
              class="py-4"
              elevation="0"
              outlined
            >
              <v-card
                elevation="0"
              >
                <div class="text-h4 px-4">
                  {{ $t('Information') }}
                </div>
                <div class="mt-8 px-4 text-body-1 font-weight-regular">
                  <div
                    class="text-h4"
                  >
                    <v-icon
                      v-if="billData.billInfo.paymentStatus==='1'"
                      class="mr-2"
                      color="success"
                    >
                      mdi-check-decagram
                    </v-icon>
                    <v-icon
                      v-else
                      class="mr-2"
                      color="error"
                    >
                      mdi-close-octagon-outline
                    </v-icon>
                    {{ paymentStatus }}
                  </div>
                </div>
                <!--                <div-->
                <!--                  v-if="historyInfo?.length > 0 && historyInfo[0].refCode !== 'returned'"-->
                <!--                  class="px-4 mt-2 text-caption"-->
                <!--                >-->
                <!--                  {{ $t('originalInvoice') }} #{{ historyInfo[0].refDOId }}-->
                <!--                </div>-->
                <v-divider class="my-4" />
                <div class="px-4">
                  <div class="text-overline font-weight-bold">
                    {{ $t('staff') }} / {{ $t('tableNumber') }}
                  </div>
                  <div class="mt-2 text-body-1 font-weight-regular">
                    {{ billData.billInfo.servantName }} / {{ showDailyNumber ? dailyNumber : billData.billInfo.tableName }}
                  </div>
                </div>
                <div class="px-4 mt-4">
                  <div class="text-overline font-weight-bold">
                    {{ $t('Customers') }}
                  </div>
                  <div class="mt-2 text-body-1 font-weight-regular">
                    {{ billData.billInfo.personCount }}
                  </div>
                </div>
                <div class="px-4 mt-4">
                  <div class="text-overline font-weight-bold">
                    {{ $t('OrderType') }}
                  </div>
                  <div class="mt-2 text-body-1 font-weight-regular">
                    {{ consumeType }}
                  </div>
                </div>
                <div
                  v-if="showCashBoxInfo"
                  class="px-4 mt-4"
                >
                  <div class="text-overline font-weight-bold">
                    {{ $t('cashBoxInfo') }}
                  </div>
                  <div class="mt-2 text-body-1 font-weight-regular">
                    {{ cashBoxInfo }}
                  </div>
                </div>
                <template v-if="rawAddressInfo">
                  <template v-if="isToGoType">
                    <v-divider class="my-4" />
                    <div class="px-4">
                      <div class="d-flex">
                        <div class="text-overline">
                          {{ $t('address_info') }}
                        </div>
                        <v-spacer />
                        <div v-if="showDetailBtn">
                          <v-btn
                            class="text-overline"
                            small
                            text
                            @click="showAddressDetailInfo = true"
                          >
                            {{ $t('Details') }}
                          </v-btn>
                        </div>
                      </div>

                      <div class="mt-2 text-body-1 font-weight-regular">
                        <address-info-block :address-info="rawAddressInfo" />
                      </div>
                    </div>
                  </template>
                  <template v-else-if="isReservation">
                    <v-divider class="my-4" />
                    <div class="px-4">
                      <div class="d-flex">
                        <div class="text-overline">
                          自助信息
                        </div>
                        <v-spacer />
                        <div v-if="showDetailBtn">
                          <v-btn
                            class="text-overline"
                            small
                            text
                            @click="showAddressDetailInfo = true"
                          >
                            {{ $t('Details') }}
                          </v-btn>
                        </div>
                      </div>

                      <div class="mt-2 text-body-1 font-weight-regular">
                        <reservation-info-block :reservation-info="rawAddressInfo" />
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <v-divider class="my-4" />
                    <div class="px-4">
                      <div class="d-flex">
                        <div class="text-overline">
                          自助信息
                        </div>
                        <v-spacer />
                        <div v-if="showDetailBtn">
                          <v-btn
                            class="text-overline"
                            small
                            text
                            @click="showAddressDetailInfo = true"
                          >
                            {{ $t('Details') }}
                          </v-btn>
                        </div>
                      </div>

                      <div class="mt-2 text-body-1 font-weight-regular">
                        <menu-info-block :menu-info="rawAddressInfo" />
                      </div>
                    </div>
                  </template>
                </template>
              </v-card>
            </v-card>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div
          class="d-flex"
        >
          <div
            :class="!$vuetify.breakpoint.mdAndUp ? 'order-1' : ''"
            class="flex-grow-1"
          >
            <v-card
              class="mt-2 pa-2"
              outlined
            >
              <div
                v-for="(b) in currentOrderDishes"
                :key="b.id"
              >
                <v-card
                  class="pa-2 mt-2 ma-1 text-body-1"
                  color="#eee"
                  elevation="0"
                >
                  <div>
                    <div class="d-flex">
                      <b>{{ b.sumCount }}&times; </b>
                      <span class="text-capitalize text-no-wrap text-truncate ml-2"> #{{
                        b.code
                      }} </span>
                      <v-spacer />
                      <template v-if="b.tempDiscountStr">
                        <span
                          class="text-decoration-line-through warning--text text--darken-1"
                          style="font-size: 10px"
                        >{{ b.price | priceDisplay }}</span>
                        <span class="text-no-wrap">
                          {{ parseFloat(b.price) + parseFloat(b.tempDiscountMod) | priceDisplay }}</span>
                      </template>
                      <span
                        v-else
                        class="text-no-wrap"
                      >{{ b.price | priceDisplay }}</span>
                    </div>
                    <div class="d-flex justify-center align-center">
                      <span class="maxLine2">{{ b.code.startsWith('ea') ? b.currentName : b.name }}</span>
                      <v-spacer />
                      <div>{{ b?.priceTaxRate | percent }}</div>
                    </div>
                  </div>
                  <template>
                    <div class="text-caption">
                      {{ b.displayMod }}
                    </div>
                  </template>
                </v-card>
              </div>
            </v-card>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <v-card
          v-if="electronicUuid"
          class="pa-4"
        >
          <div class="d-flex justify-center align-center flex-column py-6">
            <div class="d-flex">
              <div class="pa-4 white">
                <v-img
                  :aspect-ratio="1"
                  :src="'https://api.qrserver.com/v1/create-qr-code/?size=260x260&data='+ 'https://baobao.aaden.io/%23/?uuid=' + electronicUuid"
                  width="196"
                />
              </div>
            </div>
            <div
              class="d-flex align-center"
              style="cursor: pointer"
              @click="copyUuid"
            >
              {{ electronicUuid }}
              <v-icon
                class="ml-2"
                small
              >
                mdi-content-copy
              </v-icon>
            </div>
          </div>
          <div class="text-body-2 mt-1">
            {{ $t('ElectronicBillHint') }}
          </div>
          <div class="mt-4">
            <v-text-field
              v-model="email"
              :placeholder="$t('ElectronicBillReceiver')"
              hide-details
              outlined
            />
          </div>
          <div
            v-if="email"
            class="mt-4 d-flex justify-center"
          >
            <v-btn
              :loading="btnLoading"
              class="mr-2"
              color="primary"
              elevation="0"
              width="100%"
              @click="sendToEmail"
            >
              <v-icon left>
                mdi-arrow-right
              </v-icon>
              {{ $t('send') }}
            </v-btn>
          </div>
        </v-card>
        <div
          v-else
          class="pa-4"
        >
          {{ $t('noElectronicBill') }}
        </div>
      </v-tab-item>
      <v-tab-item v-if="showFrenchBill === '1'">
        <v-card
          class="pa-4"
        >
          <div
            :style="{
              display: 'grid',
              gridTemplateColumns: $vuetify.breakpoint.smAndDown ? '1fr' : 'repeat(2, minmax(0, 1fr))',
              gridGap: '16px'
            }"
          >
            <v-card
              v-for="bill in frenchBillList"
              :key="bill.id"
              class="pa-4"
              outlined
            >
              <div class="d-flex flex-column">
                <div
                  class="d-flex justify-space-between align-center mb-2"
                >
                  <template v-if="bill.cancelledAt">
                    <div class="text-subtitle-1 font-weight-medium error--text">
                      <v-icon
                        class="mr-1"
                        color="error"
                        small
                      >
                        mdi-cancel
                      </v-icon>
                    </div>
                    <div>{{ bill.cancelledAt || $t('noData') }}</div>
                  </template>
                  <template v-else>
                    <div class="text-subtitle-1 font-weight-medium error--text">
                      <v-icon
                        class="mr-1"
                        color="success"
                        small
                      >
                        mdi-check
                      </v-icon>
                    </div>
                    <v-btn
                      icon
                      small
                      @click="reprintFrenchBill(bill.id)"
                    >
                      <v-icon>mdi-cloud-print</v-icon>
                    </v-btn>
                  </template>
                </div>

                <div class="d-flex justify-space-between align-center mb-2">
                  <div class="text-subtitle-1 font-weight-medium">
                    {{ $t('PersonCount') }}
                  </div>
                  <div>{{ bill.personCount }}</div>
                </div>

                <div class="d-flex justify-space-between align-center mb-2">
                  <div class="text-subtitle-1 font-weight-medium">
                    {{ $t('createdAt') }}
                  </div>
                  <div>{{ bill.createdAt || $t('noData') }}</div>
                </div>

                <div class="d-flex justify-space-between align-center mb-2">
                  <div class="text-subtitle-1 font-weight-medium">
                    {{ $t('totalAmount') }}
                  </div>
                  <div>{{ bill.totalAmount | priceDisplay }}</div>
                </div>

                <div class="d-flex justify-space-between align-center">
                  <div class="text-subtitle-1 font-weight-medium">
                    {{ $t('note') }}
                  </div>
                  <div>{{ bill.note || $t('noData') }}</div>
                </div>
              </div>
            </v-card>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
      v-model="printContentShow"
      width="480px"
    >
      <v-card
        class="pa-4"
        width="100%"
      >
        <i-k-p-r-node
          :node="parseNode(currentPrintContent)"
          level=""
          style="font-family: monospace"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="reprintDialogShow"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div
          class="d-flex align-center"
        >
          <div class="text-h3 font-weight-bold">
            {{ $t('selectBillType') }}
          </div>
        </div>
        <div
          class="mt-4"
          style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px"
        >
          <v-card
            class="pa-4 d-flex align-center justify-center"
            color="#eee"
            elevation="0"
            height="200"
            @click="reprintOrder(1)"
          >
            <div class="text-center">
              <v-icon size="64">
                mdi-text-box
              </v-icon>
              <div>{{ $t('normalBill') }}</div>
            </div>
          </v-card>
          <v-card
            class="pa-4 d-flex align-center justify-center"
            color="#eee"
            elevation="0"
            height="200"
            @click="reprintOrder(2)"
          >
            <div class="text-center">
              <v-icon size="64">
                mdi-text-box-outline
              </v-icon>
              <div>{{ $t('companyBill_X1') }}</div>
            </div>
          </v-card>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="checkOutDialog"
      :fullscreen="!$vuetify.breakpoint.mdAndUp"
      max-width="1000px"
    >
      <v-card
        :class="!$vuetify.breakpoint.mdAndUp ?
          'rounded-br-0 rounded-bl-0' : ''"
      >
        <check-out-calculator
          :title="id.toString()"
          :total="changeOrderTotal"
          @payment-cancel="checkOutDialog=false"
          @payment-submit="changePaymentMethod"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showAddressDetailInfo"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div>
          <div class="d-flex align-center justify-center">
            <div>
              {{ $t('address_info') }}
            </div>
            <v-spacer />
            <v-btn
              icon
              @click="showAddressDetailInfo = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="mt-2 text-body-1 font-weight-regular">
            <json-viewer
              :value="rawAddressInfo"
              copyable
            />
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showDetailJson"
      max-width="600"
    >
      <v-card
        class="pa-2 ml-0 ma-1 text-body-1 mt-4"
        color="#eee"
        elevation="0"
      >
        <div class="mt-2 text-body-1 font-weight-regular">
          <json-viewer
            :value="currentJson"
            copyable
          />
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getDetailOrder, reprintOrder } from '@/model/dataLayer/service/otherService'
import AddressInfoBlock from '@/views/widget/commonLogic/base/AddressInfoBlock.vue'
import BillPaymentInfo from '@/model/dataLayer/api/bills/detail/BillPaymentInfo'
import IKUtils from 'innerken-js-utils'
import Payment from '@/model/dataLayer/api/common/Payment'
import ConsumeTypeStatus from '@/model/dataLayer/api/common/ConsumeTypeStatus'
import PrinterListByOrder, { getOneDishOrderRecords } from '@/model/dataLayer/api/bills/detail/PrinterListByOrder'
import hillo from 'hillo'
import ConsumeType from '@/model/dataLayer/api/buffet/ConsumeType'
import { groupBy } from 'lodash'
import IKPRNode from '@/views/widget/commonLogic/IKPRNode.vue'
import { parse } from 'node-html-parser'
import { changePayMethodForOrder } from '@/model/dataLayer/api/bills/historyBill'
import CheckOutCalculator from '@/views/AadenPages/components/GlobalDialog/CheckOutCalculator.vue'
import { showSuccessMessage, sureTo } from '@/model/utils/utils'
import i18n from '@/i18n'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import HistoryBills, {
  doReprintFrenchBill,
  getAllFrenchBillByOrderId,
  getUUidByOrderId,
  sendMailTo
} from '@/model/dataLayer/api/bills/HistoryBills'
import { forceGetSystemSetting } from '@/model/dataLayer/api/NewSettings'
import { formatLogDish, getOrderDetailLogById } from '@/model/dataLayer/api/bills/OrderLog'
import Servant from '@/model/dataLayer/api/tableAndPerson/Servant'
import JsonViewer from 'vue-json-viewer'
import GlobalConfig from '@/model/global/GlobalSettings'
import Dish from '@/model/dataLayer/api/dish/Dish'
import MenuInfoBlock from '@/views/widget/commonLogic/base/MenuInfoBlock.vue'
import ReservationInfoBlock from '@/views/widget/commonLogic/base/ReservationInfoBlock.vue'

export default {
  components: {
    ReservationInfoBlock,
    MenuInfoBlock,
    IKPRNode,
    AddressInfoBlock,
    CheckOutCalculator,
    BackButton,
    PageHeader,
    JsonViewer
  },
  props: {
    id: {
      default: '-1',
      type: [String, Number]
    }
  },
  data: function () {
    return {
      showDetailJson: false,
      currentJson: {},
      btnLoading: false,
      electronicUuid: '',
      email: '',
      showAddressDetailInfo: false,
      tab: null,
      billTimeLine: null,
      historyInfo: [],
      changeOrderId: null,
      changeOrderTotal: null,
      checkOutDialog: false,
      currentPrintContent: '',
      printContentShow: null,
      reprintDialogShow: null,
      BillPaymentInfo,
      loading: false,
      billData: {
        billInfo: { paymentStatus: 0 },
        billOrderInfo: [],
        billPaymentInfo: []
      },
      payMethods: [],

      rawAddressInfo: '',
      infoList: [],
      orders: [],
      defaultItem: {
        paymentMethodId: -1,
        name: ''
      },
      consumeTypeStatusList: [],
      consumeType: '',
      consumeTypeStatus: '',
      paymentStatus: '',
      paymentRecordList: [],
      printRecordList: [],
      PrinterListByOrder,
      showCashBoxInfo: false,
      servantList: [],
      showFrenchBill: '0',
      frenchBillList: [],
      allDishList: []
    }
  },
  computed: {
    showDetailBtn () {
      return GlobalConfig.mode === 'Admin'
    },
    currentOrderDishes () {
      const res = this.billData.billOrderInfo.filter(it => it.sumCount !== '0')
      res.forEach(it => {
        if (it.aName) {
          const nameList = it.aName.split(',')
          const priceList = it.priceInfo.split(',')
          const taxList = it.priceInfoTaxRate.split(',')
          it.displayMod = nameList.map((x, index) => {
            const currentTaxDisplay = (parseFloat(taxList[index]) * 100).toFixed(0) + '%'
            if (priceList[index] !== '0.00') {
              return `${x} ${priceList[index]}€(${currentTaxDisplay})`
            } else {
              return x
            }
          }).join(',')
        } else {
          it.displayMod = ''
        }
      })
      return res
    },
    dailyNumber () {
      return this.basicInfo?.dailySerial ? 'W' + this.basicInfo?.dailySerial : this.basicInfo?.tableName
    },
    showDailyNumber () {
      return this.billData?.restaurantInfo?.useDailySerialAsQueueNumber === '1' && (this.billData.billInfo.tableName.startsWith('W') || this.billData.billInfo.tableName.startsWith('w'))
    },
    isToGoType () {
      return this.basicInfo.consumeTypeId.toString() === '2'
    },
    isReservation () {
      return this.basicInfo.payMethodName === 'Stripe'
    },
    cashBoxInfo () {
      return this.basicInfo?.cashBoxId ?? ''
    },
    basicInfo () {
      return this.billData?.billInfo
    },
    dishTotalPrice () {
      return this.orders.reduce((sum, i) => sum + parseFloat(i.totalPrice), 0)
    },
    totalPrice () {
      return parseFloat(this.billData.billInfo.totalPrice ?? 0)
    },
    count () {
      return this.orders.reduce((sum, i) => sum + parseInt(i.sumCount), 0)
    },
    isReturned () {
      return this.basicInfo?.isReturned === '1'
    },
    detailedOrders () {
      return (this.billData?.orderDetailInfo ?? []).map(o => {
        let name
        switch (o.dishStatus) {
          case '-1':
            name = 'returnDish'
            break
          case '-100':
            name = 'dividedOrder'
            break
          case '-101':
            name = 'tableChanged'
            break
          default:
            name = 'orderFood'
        }
        o.dishStatusName = name
        return o
      })
    },
    displayDetailInfo () {
      const groupedInfo = groupBy(this.detailedOrders, 'time')
      for (const time in groupedInfo) {
        groupedInfo[time] = groupBy(groupedInfo[time], 'dishStatusName')
        for (const key in groupedInfo[time]) {
          const timeInfo = groupBy(groupedInfo[time][key], (i) => {
            return i.currentCode + i.name + i.note + i.aName + i.tempDiscountStr
          })
          groupedInfo[time][key] = Object.keys(timeInfo).reduce((arr, i) => {
            arr.push(timeInfo[i].reduce((obj, t) => {
              obj.count = parseInt(obj.count) + parseInt(t.count)
              return obj
            }))
            return arr
          }, [])
        }
      }
      return groupedInfo
    },
    displayTimeLineDetail () {
      for (const timeLine of this.billTimeLine) {
        timeLine.detailInfo = timeLine?.opReq ? JSON.parse(timeLine?.opReq) : {}
        timeLine.lastDODId = timeLine?.opResp ? JSON.parse(timeLine?.opResp) : {}
        if (timeLine.eventName === 'addDishToOrder') {
          timeLine.dishInfo = formatLogDish(timeLine.detailInfo.params.dish_info)
          if (timeLine.dishInfo?.dishId) {
            timeLine.currentDishInfo = this.currentOrderDishes.find(it => it?.dishesId.toString() === timeLine.dishInfo?.dishId.toString())
          } else if (timeLine.dishInfo?.dishesId) {
            timeLine.currentDishInfo = this.currentOrderDishes.find(it => it?.dishesId.toString() === timeLine.dishInfo?.dishesId.toString())
          } else if (timeLine.dishInfo?.id) {
            timeLine.currentDishInfo = this.currentOrderDishes.find(it => it?.dishesId.toString() === timeLine.dishInfo?.id.toString())
          } else {
            timeLine.currentDishInfo = ''
          }
          const list = this.billData?.orderDetailInfo ?? []
          if (!timeLine.dishInfo.price) {
            timeLine.dishInfo.price = list.find(it => it.id.toString() === timeLine?.lastDODId?.lastDODId.toString())?.price ?? ''
          }
          timeLine.servantName = list.find(it => it.id.toString() === timeLine?.lastDODId?.lastDODId.toString())?.servantName ?? ''
        } else {
          timeLine.servantName = timeLine?.servantId ? this.servantList.find(it => it.id.toString() === timeLine.servantId)?.name : ''
        }
        if (timeLine.eventName === 'removeDishFromOrder') {
          timeLine.nameDisplay = this.allDishList.find(it => it.dishId === timeLine.detailInfo.params.tt_dish.dishesId)?.dishName
        }
      }
      const groupedInfo = groupBy(this.billTimeLine, 'createdAt')
      for (const time in groupedInfo) {
        groupedInfo[time] = groupBy(groupedInfo[time], 'eventName')
      }
      const res = []
      Object.entries(groupedInfo).forEach((it) => {
        Object.entries(it[1]).forEach(x => {
          res.push({ time: it[0], eventName: x[0], value: x[1] })
        })
      })
      return res
    }
  },
  watch: {
    id: {
      immediate: true,
      handler: function () {
        this.reloadItem(this.id)
      }
    }
  },
  async mounted () {
    this.servantList = await Servant.getList()
    this.consumeTypeStatusList = await ConsumeTypeStatus.getList()
    this.payMethods = (await Payment.getList())
    this.historyInfo = (await HistoryBills.getList())
      .find(it => it.orderId === this.id)?.orderMeta ?? []
    this.electronicUuid = await getUUidByOrderId(this.id)
    this.allDishList = await Dish.getList(true)
    const res = await forceGetSystemSetting({
      section: 'CashBox',
      sKey: 'enabled',
      sValue: '0',
      defaultValue: '0',
      sType: 'boolean',
      minimumVersion: '1.7.825',
      sOptions: '',
      tagList: 'basic,cash,box'
    })
    if (res === '1') {
      this.showCashBoxInfo = true
    }
    this.showFrenchBill = await forceGetSystemSetting({
      section: 'aadenAdmin',
      sKey: 'useFrenchBill',
      sValue: '0',
      defaultValue: '0',
      sType: 'boolean',
      minimumVersion: '1.7.784',
      sOptions: '',
      tagList: 'basic'
    })
    if (this.showFrenchBill === '1') {
      this.frenchBillList = await getAllFrenchBillByOrderId(this.id)
    }
  },
  methods: {
    changeFromTableInfo (info) {
      if (info.includes('change from table')) {
        return info.match(/^change from table\([^)]+\)/)[0]
      } else {
        return ''
      }
    },
    changeToTableInfo (info) {
      if (info.includes('change to table')) {
        return info.match(/^change to table\([^)]+\)/)[0]
      } else {
        return ''
      }
    },
    async reprintFrenchBill (id) {
      await doReprintFrenchBill(id)
    },
    showJson (info) {
      if (GlobalConfig.mode === 'Admin') {
        this.currentJson = info?.detailInfo
        this.showDetailJson = true
      }
    },
    async sendToEmail () {
      this.btnLoading = true
      await sendMailTo(this.email, this.electronicUuid)
      this.email = ''
      showSuccessMessage(i18n.t('successful'))
      this.btnLoading = false
    },
    async closeDialog () {
      this.$emit('close-dialog')
    },
    startChangePaymentMethodForOrder () {
      this.changeOrderId = this.id
      this.changeOrderTotal = this.totalPrice
      this.checkOutDialog = true
    },
    async changePaymentMethod (paymentLog = []) {
      if (paymentLog?.length === 0) {
        paymentLog = [
          {
            id: 1,
            price: this.changeOrderTotal
          }
        ]
      }
      IKUtils.showLoading()
      await changePayMethodForOrder(this.changeOrderId, paymentLog)
      showSuccessMessage(i18n.t('edit_success'))
      this.checkOutDialog = false
      this.$emit('close-dialog')
      this.$emit('close-reload')
    },
    parseNode (node) {
      return parse(node)
    },
    formatItem () {
      for (const i of this.payMethods) {
        i.name = this.findLangInArray(i.langs).name
      }
    },
    loadDetail: async function (id) {
      this.billTimeLine = (await getOrderDetailLogById(id))
      const res = await getDetailOrder(id)
      this.billData = res
      const list = await ConsumeType.getList()

      if (this.billData.billOrderInfo) {
        this.orders = this.billData.billOrderInfo.map((item, index) => ({
          id: index,
          consumeTypeName:
              item.overrideConsumeTypeId
                ? list.find(i => i.id === parseInt(item.overrideConsumeTypeId))?.name
                : '',
          ...item
        }))
      } else {
        this.orders = this.billData.orderDetailInfo.map((item) => ({
          id: item.id,
          sumCount: item.count,
          code: item.currentCode,
          name: item.name,
          note: item.note,
          aName: item.aName,
          stamp: item.time,
          consumeTypeName: '',
          totalPrice: item.price
        }))
      }
      try {
        this.rawAddressInfo = this.billData?.billInfo?.rawAddressInfo ? JSON.parse(this.billData.billInfo.rawAddressInfo) : ''
      } catch (e) {

      }

      this.paymentStatus = this.billData.billInfo.paymentStatus === '1'
        ? this.$i18n.t('paid')
        : this.$i18n.t(
          'not_paid')
      this.consumeTypeStatus = this.consumeTypeStatusList.find(i =>
        parseInt(this.billData.billInfo.consumeTypeStatusId) === i.id)?.name ?? 'unknown'
      this.consumeType = list.find(i => parseInt(this.billData.billInfo.consumeTypeId) === i.id)?.name
      for (const item of this.payMethods) {
        if (parseInt(item.id) === parseInt(this.billData.billInfo.payMethod)) {
          this.defaultItem.name = item.name
        }
      }
      this.infoList = [
        {
          keyname: this.$i18n.t('orderNumber') + '/' + this.$i18n.t('tableNumber'),
          value: this.billData.billInfo.id + '/' + this.billData.billInfo.tableName
        },
        {
          keyname: this.$i18n.t('staff'),
          value: this.billData.billInfo.servantName
        },
        {
          keyname: this.$i18n.t('startTime'),
          value: this.billData.billInfo.startTime
        },
        {
          keyname: this.$i18n.t('checkout_time'),
          value: this.billData.billInfo.endTime
        },
        {
          keyname: this.$i18n.t('tipIncome'),
          value: this.billData.billInfo.tipIncome
        },
        {
          keyname: this.$i18n.t('discount'),
          value: this.billData.billInfo.discountStr
        },
        {
          keyname: this.$i18n.t('totalPrice'),
          value: this.billData.billInfo.totalPrice
        }
      ]
      this.paymentRecordList = res?.billPaymentInfo.map(item => {
        item.paymentMethodName = this.findPaymentName(item.paymentMethodId)
        item.createdAt = item.createdAt ?? ''
        return item
      }) ?? []
      this.printRecordList = await getOneDishOrderRecords(this.id)
    },
    findPaymentName (id) {
      return this.payMethods.find(it => parseInt(it.id) === parseInt(id))?._langsname ?? ''
    },
    async reloadItem (id) {
      this.formatItem()
      await this.loadDetail(id)
    },
    async returnOrder () {
      await sureTo(async () => {
        await this.returnOrderAPI(this.id)
        showSuccessMessage(this.$t('Erfolgreich'))
        this.$emit('close-dialog')
        this.$emit('close-reload')
      }, this.$t('are_you_sure'), this.$t('You want to return this order'))
      // await IKUtils.showConfirm(this.$t('are_you_sure'), this.$t('You want to return this order') + '.', () => {
      //   this.returnOrderAPI(this.id)
      //   showSuccessMessage(this.$t('Erfolgreich'))
      //   this.$emit('close-dialog')
      //   this.$emit('close-reload')
      // })
    },
    async returnOrderAPI (id) {
      await hillo.post('Complex.php?op=returnOrder', { orderId: this.id })
    },

    async reprintOrder (value) {
      value = parseInt(value)
      let withTitle = 0
      let printCount = 1
      if (value > 1) {
        withTitle = 1
      }
      if (value > 2) {
        printCount = 2
      }
      await reprintOrder(this.id, withTitle, printCount)
      showSuccessMessage(this.$t('print_success'))
      this.reprintDialogShow = false
    },
    findLangInArray (langArray, target = i18n.locale) {
      return langArray.find((item) => {
        return item.lang.toLowerCase() === target.toLowerCase()
      })
    },
    async reprint (item) {
      await this.PrinterListByOrder.reprint(item)
      showSuccessMessage()
    },
    async copyUuid () {
      await navigator.clipboard.writeText(this.electronicUuid)
      showSuccessMessage(this.$t('successful'))
    }
  }
}
</script>

<style scoped>
td {
  padding: 4px 0;
}
</style>
